import React from 'react';
import Icon from 'components/icon';

const globals = {
  AboutBlurb: <span>About!</span>,
  FooterInfo: <span>&copy; 2018 Roosevelt Collier.<br/><span className="o5">All Rights Reserved.</span></span>,
  SignUpHeadline: <h2>Sign up for our insider email list.</h2>,
  SignUpSubtitle: <p>No annoying spam. Just the freshest updates from Roosevelt Collier as they happen.</p>
};

export default globals;
